export default {
  IMG_404_LAMP:
    "https://www.manipalcigna.com/o/manipal-cigna-theme/images/icons/lamp.png",
  IMG_404_CIRCLE:
    "https://www.manipalcigna.com/o/manipal-cigna-theme/images/icons/circle.png",
  IMG_404_TABLE_CHAIR:
    "https://www.manipalcigna.com/o/manipal-cigna-theme/images/icons/table-chair.png",
  LOADER_MCHI_GIF:
    "https://www.manipalcigna.com/o/manipal-cigna-theme/images/ManipalCigna-Loder.gif",
  IMG_MCHI_LOGO:
    "https://www.manipalcigna.com/image/layout_set_logo?img_id=432304&t=1640055811625",
  // IMG_MCHI_LOGO_LOCAL: require("../images/logo/Manipal_Logo.png").default,
  IMG_MCHI_LOGO_LOCAL:
    "https://www.manipalcigna.com/image/layout_set_logo?img_id=432304&t=1654657419370",
  IMG_BOM_LOGO:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Bank_of_Maharashtra_logo.svg/2560px-Bank_of_Maharashtra_logo.svg.png",
};
